import { makeStyles, tokens } from '@fluentui/react-components';
import { IPStackStyles, IPStackTokens } from 'baseComponents/Stack/IPStack';

//
// Shared spacing and text styles, on Fluent v9 tokens. Colours always come from `tokens`, so light and dark
// mode follow the theme provider; never branch on appContext.useDarkMode for a colour.
//

// Spacing
export const globalPaddingScene: number = 16;

export const globalStackTokensGapExtraSmall: IPStackTokens = { childrenGap: 4 };
export const globalStackTokensGapSmall: IPStackTokens = { childrenGap: 8 };
export const globalStackTokensGapMedium: IPStackTokens = { childrenGap: 16 };
export const globalStackTokensGapLarge: IPStackTokens = { childrenGap: 24 };

export const globalStackStylesPaddingScene: IPStackStyles = {
  root: { paddingLeft: globalPaddingScene, paddingRight: globalPaddingScene },
};

export const globalStackStylesNoHeightPaddingSmall: IPStackStyles = {
  root: { padding: 8 },
};

// Text
export const useGlobalTextStyles = makeStyles({
  bold: {
    fontWeight: tokens.fontWeightSemibold,
  },
  noWrap: {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  category: {
    color: tokens.colorNeutralForeground3,
    fontWeight: tokens.fontWeightSemibold,
    textTransform: 'uppercase',
    letterSpacing: '0.04em',
  },
  validationError: {
    color: tokens.colorPaletteRedForeground1,
  },
  subtle: {
    color: tokens.colorNeutralForeground3,
  },
});
